// extracted by mini-css-extract-plugin
export default {"image-container":"fullimage_image-container__so+eP"};